(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("forge"), require("localforage"));
	else if(typeof define === 'function' && define.amd)
		define(["forge", "localforage"], factory);
	else if(typeof exports === 'object')
		exports["ca"] = factory(require("forge"), require("localforage"));
	else
		root["ca"] = factory(root["forge"], root["localforage"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition